import type { IHomeLoanProductCommission } from './HomeLoanProductCommission.interface';

export default class HomeLoanProductCommission implements IHomeLoanProductCommission {
  loanAccountNumber: string;
  offsetAccountNumber: string;

  static build = (data: IHomeLoanProductCommission) => new HomeLoanProductCommission(data);
  static blank = () => new HomeLoanProductCommission();

  /**
   * Constructor
   * @param {IHomeLoanProductCommission} data
   */
  constructor(data?: IHomeLoanProductCommission) {
    this.loanAccountNumber = data?.loanAccountNumber || '';
    this.offsetAccountNumber = data?.offsetAccountNumber || '';
  }
}
